import { useTranslation } from "react-i18next";
import "./confirm.css";
import { fmtMoney, fmtQty } from "../../lib/format";

// جدول بنود الأمر كما يراه المورّد + الإجمالي البارز + الأقساط.
export const ConfirmOrderTable = ({ order }) => {
  const { t } = useTranslation();

  return (
    <section className="pc-card" data-testid="confirm-lines">
      <table className="pc-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{t("purchases.print.item")}</th>
            <th>{t("purchases.print.qty")}</th>
            <th>{t("purchases.print.uom")}</th>
            <th>{t("purchases.print.price")}</th>
            <th>{t("purchases.print.total")}</th>
          </tr>
        </thead>
        <tbody>
          {(order.lines || []).map((line) => (
            <tr key={line.line_no} data-testid={`confirm-line-${line.line_no}`}>
              <td className="pc-num">{line.line_no}</td>
              <td style={{ textAlign: "start", fontWeight: 700 }}>{line.description}</td>
              <td className="pc-num">{fmtQty(line.quantity)}</td>
              <td>{line.uom}</td>
              <td className="pc-num">{fmtMoney(line.unit_price)}</td>
              <td className="pc-num">{fmtMoney(line.line_total)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pc-total" data-testid="confirm-total">
        <span>{t("purchases.print.grandTotal")}</span>
        <span className="pc-num">{fmtMoney(order.totals?.payable)} {order.currency}</span>
      </div>

      {order.payment_installments?.length ? (
        <div style={{ padding: "0 16px 14px", display: "grid", gap: 4 }}
             data-testid="confirm-installments">
          {order.payment_installments.map((item) => (
            <p key={item.number} style={{ fontSize: 12, color: "#4b5563", fontWeight: 700 }}>
              {item.label || `${t("purchases.installments.label")} ${item.number}`} ·{" "}
              <span className="pc-num">{item.due_date || "—"}</span> ·{" "}
              <span className="pc-num">{fmtMoney(item.amount)}</span>
            </p>
          ))}
        </div>
      ) : null}
    </section>
  );
};
